import type { ReactNode } from 'react';

export const symbol_lda: ReactNode = (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960">
		<path
			fill="currentColor"
			d="m450-213-213-90q-17.37-6.69-27.18-21.93Q200-340.16 200-358v-102q0-24.75 17.63-42.38Q235.25-520 260-520h190v-120h-70q-24.75 0-42.37-17.63Q320-675.25 320-700v-120q0-24.75 17.63-42.38Q355.25-880 380-880h200q24.75 0 42.38 17.62Q640-844.75 640-820v120q0 24.75-17.62 42.37Q604.75-640 580-640h-70v120h190q24.75 0 42.38 17.62Q760-484.75 760-460v102q0 17.84-9.82 33.07Q740.37-309.69 723-303l-213 90v103q0 12.75-8.68 21.37-8.67 8.63-21.5 8.63-12.82 0-21.32-8.63Q450-97.25 450-110v-103Zm-70-487h200v-120H380v120Zm70 422v-182H260v102l190 80Zm60 0 190-80v-102H510v182ZM380-700v-120 120Z"
		/>
	</svg>
);
